import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2 className='text-primary text-center'>404 Not found!</h2>
        </div>
    );
};

export default NotFound;